/**
 * activity redux actions
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {START_ACTIVITY, FINISH_ACTIVITY} from "./consts";


export const startActivityAction = (activityId, description) => ({
    type: START_ACTIVITY,
    activityId: activityId,
    description: description
});

export const finishActivityAction = (activityId) => ({
    type: FINISH_ACTIVITY,
    activityId: activityId
});